module.exports = __webpack_public_path__ + "static/media/explore.50047122.jpg";